import { Button } from "@nextui-org/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaThumbsUp } from "react-icons/fa";
import success_bg from "../assets/images/success_bg.png";

const SuccessPlaceholder = ({ onPress = () => {} }) => {
  const { t } = useTranslation();
  return (
    <div className="p-12 py-24 flex flex-col items-center gap-y-8">
      <div
        className="w-full max-w-xs pt-8 flex justify-center items-end bg-contain bg-no-repeat bg-top"
        style={{ backgroundImage: `url("${success_bg}")` }}
      >
        <div className="w-52 h-52 rounded-full bg-[#605BFF] bg-opacity-20 p-4 flex justify-center items-center">
          <FaThumbsUp className="w-16 h-16 text-primary" />
        </div>
      </div>
      <h3 className="text-xl font-semibold  text-gray-500">{t("Upload successful.")}</h3>
      <Button
        color="primary"
        className="w-full max-w-[150px]"
        onPress={onPress}
      >
        {t("Close")}
      </Button>
    </div>
  );
};

export default SuccessPlaceholder;
